import { useTranslation } from "react-i18next";
import createDOMPurify from "dompurify";

import { getEvidenceTitle } from "@/domains/evidence/hooks/useEvidenceFields";
import {
  DataBlockContent,
  DataBlockDetails,
} from "@/domains/datablocks/components/DataBlockContent";
import { DataTemplateWithExamples } from "@/features/datablocks/documentation/types";

import "../styles.css";

export const EvidenceExample = ({
  template,
}: {
  template: DataTemplateWithExamples;
}) => {
  const { t } = useTranslation();
  const DOMPurify = createDOMPurify(window);

  return (
    <div className="data-template-example">
      <h2 className="header-m-medium">{template.title}</h2>

      <div>
        <h3 className="header-s-medium">
          {t("datablocks.labels.description")}
        </h3>
        <div>
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(template.fullDescription || "", {
                USE_PROFILES: { html: true },
              }),
            }}
          />
        </div>
      </div>

      {template.examples && template.examples.length > 0 ? (
        <div className="data-template-example-items">
          <div className="data-template-example-container">
            {template.examples.map((example) => (
              <div key={example.id} className="data-template-example-item">
                <h3 className="header-s-medium">{getEvidenceTitle(example)}</h3>

                <DataBlockDetails dataBlock={example} dataTemplate={template} />

                <DataBlockContent dataBlock={example} dataTemplate={template} />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};
